import { render, staticRenderFns } from "./LogotypesSlider.vue?vue&type=template&id=ae824f60&scoped=true&"
import script from "./LogotypesSlider.vue?vue&type=script&lang=js&"
export * from "./LogotypesSlider.vue?vue&type=script&lang=js&"
import style0 from "./LogotypesSlider.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./LogotypesSlider.vue?vue&type=style&index=1&id=ae824f60&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae824f60",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSlideGroup } from 'vuetify/lib/components/VSlideGroup';
import { VSlideItem } from 'vuetify/lib/components/VSlideGroup';
installComponents(component, {VSlideGroup,VSlideItem})
